import { useState } from 'react';
import emailjs from '@emailjs/browser';
import './contactForm.css'

const ContactForm = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateMessage, setStateMessage] = useState<string | null>(null);
    const sendEmail = (e: React.BaseSyntheticEvent) => {
        e.persist();
        e.preventDefault();

        const form = e.target;
        const userName = form.user_name.value.trim();
        const userEmail = form.user_email.value.trim();
        const message = form.message.value.trim();

        // Validate form fields
        if (!userName || !userEmail || !message) {
            setStateMessage('All fields are required.');
            setTimeout(() => {
                setStateMessage(null);
            }, 5000); // hide message after 5 seconds
            return;
        }

        // Email validation (basic)
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(userEmail)) {
            setStateMessage('Please enter a valid email address.');
            setTimeout(() => {
                setStateMessage(null);
            }, 5000); // hide message after 5 seconds
            return;
        }

        setIsSubmitting(true);
        setStateMessage('Sending message.');

        emailjs.sendForm(
            'service_wfgp6y8',
            'template_ivoaq5o',
            form,
            '1xYehvNGLThtEEeXM'
        ).then((result) => {
            setStateMessage('Message sent!');
            setIsSubmitting(false);
            setTimeout(() => {
                setStateMessage(null);
            }, 5000); // hide message after 5 seconds
        },
        (error) => {
            setStateMessage('Something went wrong, please try again later.');
            setIsSubmitting(false);
            setTimeout(() => {
                setStateMessage(null);
            }, 5000); // hide message after 5 seconds
        });

        form.reset();
    };
    return (
        <form onSubmit={sendEmail}>
            <input type="text" name="user_name" placeholder="Your Name" required/>
            <input type="email" name="user_email" placeholder="Your Email" required/>
            <textarea rows={8} cols={80} name="message" placeholder="Message" required></textarea>
            <div className="form-footer">
                {stateMessage && <p>{stateMessage}</p>}
                <button type="submit" disabled={isSubmitting}>Send</button>
            </div>
        </form>
    );
};

export default ContactForm;